export default __webpack_public_path__ + "static/media/M.3.3.4bce9358.svg";